import MetaTags from "react-meta-tags"
import React from "react"
import { Container } from "reactstrap"
import LeadField from "../../components/Admin/LeadFields"

const Ldfield = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Custom Fields | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <LeadField />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Ldfield
